// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/Imprint.tsx
// Version: v2.1.0
// Description: Imprint page — real ESTATA data, Partners-style layout

import React from "react";
import { useBreakpoints } from "../hooks/Breakpoints.tsx";
import Container from "../hooks/Container.tsx";

const Imprint: React.FC = () => {
  const { current } = useBreakpoints();
  const isDesktop = current === "desktop";
  const isTablet = current === "tablet";

  const titleSize = isDesktop ? "text-7xl" : isTablet ? "text-5xl" : "text-3xl";
  const h2Size = isDesktop ? "text-3xl" : isTablet ? "text-2xl" : "text-xl";
  const bodySize = isDesktop ? "text-lg" : isTablet ? "text-base" : "text-sm";

  return (
    <section className="bg-black text-white pt-[50px] pb-[50px] sm:pt-[75px] sm:pb-[75px] lg:pt-[100px] lg:pb-[100px]">
      <Container>
        <h1 className={`font-bold mb-16 ${titleSize}`}>Impressum</h1>

        <div className={`grid grid-cols-1 ${isDesktop ? "md:grid-cols-2 gap-x-12" : ""} gap-y-12`}>
          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Angaben gemäß § 5 TMG</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              ESTATA GmbH<br />
              Katharinenstraße 9<br />
              10711 Berlin
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Vertreten durch</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Safet Ramadani, Geschäftsführer<br />
              Andreas Sutic, Geschäftsführer
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Kontakt</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Telefon: +49 30 6298 7730<br />
              E-Mail: info@estata.com
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Handelsregister</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Registergericht: Amtsgericht Berlin-Charlottenburg<br />
              Registernummer: HRB XXXXX
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Umsatzsteuer-ID</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Umsatzsteuer-Identifikationsnummer<br />
              gemäß § 27a UStG: DE XXXXXXXXX
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>Datenschutzbeauftragter</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Ines Gebhardt<br />
              ESTATA GmbH<br />
              Katharinenstraße 9<br />
              10711 Berlin
            </p>
          </div>
        </div>

        <div className="mt-16">
          <h2 className={`${h2Size} font-semibold mb-3`}>Haftung für Inhalte</h2>
          <div className="h-px bg-white/20 mb-4" />
          <p className={`${bodySize} text-white/80 mb-8`}>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit
            und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir
            gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          </p>

          <h2 className={`${h2Size} font-semibold mb-3`}>Haftung für Links</h2>
          <div className="h-px bg-white/20 mb-4" />
          <p className={`${bodySize} text-white/80 mb-8`}>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          </p>

          <h2 className={`${h2Size} font-semibold mb-3`}>Urheberrecht</h2>
          <div className="h-px bg-white/20 mb-4" />
          <p className={`${bodySize} text-white/80`}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Imprint;
